/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminFleetMember,
  AdminFleetMemberUpdateInput,
  AdminFleetMembers,
  FleetMembersParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Fleet Members list
 */
export const fleetMembers = (
    fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
params = toValue(params);

      return axiosClient<AdminFleetMembers>(
      {url: `/fleets/${fleetId}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMembersQueryKey = (fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,) => {
    return [
    'fleets',fleetId,'members', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMembersQueryOptions = <TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMembersQueryKey(fleetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMembers>>> = ({ signal }) => fleetMembers(fleetId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>
}

export type FleetMembersQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMembers>>>
export type FleetMembersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Members list
 */

export function useFleetMembers<TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMembersQueryOptions(fleetId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove Fleet Member
 */
export const removeFleetMember = (
    fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetId}/members/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getRemoveFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFleetMember>>, TError,RemoveFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeFleetMember>>, TError,RemoveFleetMemberMutationVariables, TContext> => {

const mutationKey = ['removeFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFleetMember>>, RemoveFleetMemberMutationVariables> = (props) => {
          const {fleetId,id} = props ?? {};

          return  removeFleetMember(fleetId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeFleetMember>>>

    export type RemoveFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type RemoveFleetMemberMutationVariables = {fleetId: string;id: string}

    /**
 * @summary Remove Fleet Member
 */
export const useRemoveFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFleetMember>>, TError,RemoveFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeFleetMember>>,
        TError,
        RemoveFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Member
 */
export const fleetMember = (
    fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
id = toValue(id);

      return axiosClient<AdminFleetMember>(
      {url: `/fleets/${fleetId}/members/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetMemberQueryKey = (fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetId,'members',id
    ] as const;
    }


export const getFleetMemberQueryOptions = <TData = Awaited<ReturnType<typeof fleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMemberQueryKey(fleetId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMember>>> = ({ signal }) => fleetMember(fleetId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>
}

export type FleetMemberQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMember>>>
export type FleetMemberQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Member
 */

export function useFleetMember<TData = Awaited<ReturnType<typeof fleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMemberQueryOptions(fleetId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Member
 */
export const updateFleetMember = (
    fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    adminFleetMemberUpdateInput: MaybeRefOrGetter<AdminFleetMemberUpdateInput>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
id = toValue(id);
adminFleetMemberUpdateInput = toValue(adminFleetMemberUpdateInput);

      return axiosClient<AdminFleetMember>(
      {url: `/fleets/${fleetId}/members/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: adminFleetMemberUpdateInput, signal
    },
      );
    }




export const getUpdateFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext> => {

const mutationKey = ['updateFleetMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetMember>>, UpdateFleetMemberMutationVariables> = (props) => {
          const {fleetId,id,data} = props ?? {};

          return  updateFleetMember(fleetId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetMember>>>
    export type UpdateFleetMemberMutationBody = AdminFleetMemberUpdateInput
    export type UpdateFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetMemberMutationVariables = {fleetId: string;id: string;data: AdminFleetMemberUpdateInput}

    /**
 * @summary Update Fleet Member
 */
export const useUpdateFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetMember>>,
        TError,
        UpdateFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Login as Fleet Member
 */
export const loginAsFleetMember = (
    fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetId}/members/${id}/login-as`, method: 'GET', signal
    },
      );
    }




export const getLoginAsFleetMemberQueryKey = (fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetId,'members',id,'login-as'
    ] as const;
    }


export const getLoginAsFleetMemberQueryOptions = <TData = Awaited<ReturnType<typeof loginAsFleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAsFleetMember>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLoginAsFleetMemberQueryKey(fleetId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginAsFleetMember>>> = ({ signal }) => loginAsFleetMember(fleetId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginAsFleetMember>>, TError, TData>
}

export type LoginAsFleetMemberQueryResult = NonNullable<Awaited<ReturnType<typeof loginAsFleetMember>>>
export type LoginAsFleetMemberQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Login as Fleet Member
 */

export function useLoginAsFleetMember<TData = Awaited<ReturnType<typeof loginAsFleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginAsFleetMember>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginAsFleetMemberQueryOptions(fleetId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






